export const PLYWOOD_PRODUCTION_DONE_REQUEST = "PLYWOOD_PRODUCTION_DONE_REQUEST";
export const PLYWOOD_PRODUCTION_DONE_SUCCESS = "PLYWOOD_PRODUCTION_DONE_SUCCESS";
export const PLYWOOD_PRODUCTION_DONE_FAILED = "PLYWOOD_PRODUCTION_DONE_FAILED";